var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1271,
    viewBox: "0 0 2500 1271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M2266.31 602.877H1822.47V608.181H1744.55L1746.59 1009.59H1720.49V1063.85H2266.31V602.877Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1534.46 721.758V608.18H1746.59V721.758V1008.78H1484.7V721.758H1534.46Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1982.79 127.626V466.625H1822.47V520.881V602.469H2266.31V127.626H1982.79Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M1483.06 484.405V126.811H1748.23V211.095H1723.71L1727.39 542.094H1503.9V484.405H1483.06Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1205.67 126.811V203.534V208.897H1233.37V236.121H1219.92V607.365H1483.5V582.48H1441.86V542.094H1503.46V486.092H1483.5V126.811H1205.67Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1219.94 606.548H888.287V722.811H961.309V1082.62H1233V946.771H1219.94V606.548Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M887.471 469.601V557.232V607.364H1219.26V234.427H1233.4V207.934H1206.33V143.943H954.556V469.601H887.471Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M421.603 143.943V339.347V372.798H329V741.169H468.108V662.844H799.356V597.981H685.54V143.943H421.603Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M465.661 662.436H801.804H889.103V723.627H960.085V1083.02H680.646H553H425.683V1002.25V869.67H360.412V850.089H329.816V741.169H465.661V662.436Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1219.13 608.18H1483.88H1534.47V723.219H1483.88V1008.78H1233V945.139H1219.13V608.18Z",
    fill: "#E32009",
    fillOpacity: 0.2,
    stroke: "#E32009",
    strokeWidth: 4.89529
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor15);
export default __webpack_public_path__ + "static/media/select-floor-15.6b41a317.svg";
export { ForwardRef as ReactComponent };